<template>
  <div class="flex min-h-full sm:content-center sm:items-center">
    <div class="container mx-auto">
      <div class="container mx-auto w-full sm:max-w-lg">
        <div class="bg-white sm:rounded-lg sm:shadow-xl p-4">
          <h3 class="text-3xl font-bold text-black text-center pt-4 pb-2">
            Live Storms Media
          </h3>
          <p class="text-center">Content Distribution Platform</p>

          <div class="px-6 py-4 mt-8">
            <!-- password reset message, success -->
            <div class="mb-4 text-blue-600" v-if="status == 'password_reset'">
              <span
                >Your password has been successfully reset. You may now log
                in.</span
              >
            </div>
            <!-- errors -->
            <div class="mb-4 text-center" v-if="error">
              <span class="text-red-600">Invalid username or password.</span>
            </div>

            <div class="space-y-4 mb-8">
              <div class="block space-y-2" data-children-count="1">
                <label
                  for="email"
                  class="block text-sm font-medium text-gray-700"
                  :class="{ 'text-red-600': error }"
                  >Email</label
                >
                <input
                  type="email"
                  name="email"
                  id="email"
                  v-model="email"
                  required
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  :class="{
                    'border-red-400 focus:border-red-600 text-red-600': error
                  }"
                  @keyup.enter="loginButtonClicked"
                  tabindex="1"
                />
              </div>
              <div class="block space-y-2" data-children-count="1">
                <label
                  for="password"
                  class="block text-sm font-medium text-gray-700 flex flex-row justify-between items-center"
                  :class="{ 'text-red-600': error }"
                  >Password
                  <router-link
                    to="/password/reset"
                    class="text-xs text-blue-600"
                    tabindex="4"
                    >Forgot password?</router-link
                  >
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  v-model="password"
                  required
                  class="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                  :class="{
                    'border-red-400 focus:border-red-600 text-red-600': error
                  }"
                  @keyup.enter="loginButtonClicked"
                  tabindex="2"
                />
              </div>
            </div>

            <div class="flex justify-center items-center">
              <button
                class="text-white rounded py-2 px-6 focus:outline-none w-full focus:bg-blue-700"
                :class="{
                  'bg-blue-600 hover:bg-blue-700': !loggingIn,
                  'cursor-wait bg-blue-400': loggingIn
                }"
                v-on:click="loginButtonClicked"
                :disabled="loggingIn == true"
                tabindex="3"
              >
                <span v-if="!loggingIn">Login</span>
                <span v-if="loggingIn">Validating credentials...</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <footer
        class="container mx-auto w-full sm:max-w-md mt-10 text-center text-gray-500 text-sm"
      >
        <span class="block sm:inline"
          >&copy;2016-{{ new Date().getFullYear() }} Live Storms Media, LLC.
        </span>
        <span class="block sm:inline">All rights reserved.</span>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
      email: null,
      password: null,
      loggingIn: false,
      error: false,
      status: null
    };
  },
  mounted() {
    if (this.$route.query.status !== undefined) {
      this.status = this.$route.query.status;
    }
  },
  methods: {
    ...mapActions(["login"]),
    loginButtonClicked() {
      this.loggingIn = true;
      var self = this;

      this.login({ email: this.email, password: this.password })
        .then(response => {
          setTimeout(function() {
            if (response == 400 || response == 401) {
              self.error = true;
              self.loggingIn = false;
            } else {
              self.loggingIn = false;
              self.$router.replace(self.$route.query.redirect || "/");
            }
          }, 500);
        })
        .catch(data => {
          this.error = data.message;
          this.errors = data.errors || {};

          setTimeout(function() {
            self.loggingIn = false;
          }, 500);
        });
    },
    showBetaMessage() {
      return process.env.VUE_APP_VERCEL_ENV !== "production";
    }
  }
};
</script>
